import { render, staticRenderFns } from "./JoszakiMessage.vue?vue&type=template&id=27339608"
import script from "./JoszakiMessage.vue?vue&type=script&lang=js"
export * from "./JoszakiMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports